import './DetailsMobileContent.scss';

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { useParams } from "react-router-dom";

import { fetchDetails } from "../../../slices/detailsSlice";

import DetailsMobileTools from "../DetailsMobileTools/DetailsMobileTools";

const DetailsMobileContent = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token);
    const attributes = useSelector((state) => state.details?.columns?.attributes || []);
    const data = useSelector((state) => state.details.data);

    useEffect(() => {
        dispatch(fetchDetails({ departureId: id, token }));
    }, [dispatch, id, token]);

    const fields = attributes.map((attribute) => {
        let value = data?.attributes?.[attribute.key];

        if (typeof value === "boolean") {
            value = value ? "Да" : "Нет";
        } else if (value === undefined || value === null) {
            value = "Отсутствует";
        }

        return {
            name: attribute.alias || attribute.name,
            value,
        };
    });

    return (
        <div className={"details-mobile-content"}>
            <div className={"details-mobile-content_container"}>
                <div className={"details-mobile-content_tools"}>
                    <DetailsMobileTools title={"Донесение"}/>
                </div>
                <div className={"details-mobile-content_list"}>
                    {fields.map((item, index) => (
                        <div className={"details-mobile-content_field"} key={index}>
                            <div className={"details-mobile-content_title"}>
                                {item.name}
                            </div>
                            <div className={"details-mobile-content_description"}>
                                {item.value}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default DetailsMobileContent;